import _extends from '@babel/runtime/helpers/extends';
import React from 'react';
import PropTypes from 'prop-types';
import { p as props } from './componentEl-c8b73b10.js';
import { a as addSpacingClasses, m as marginPropTypes } from './spacing-7e57ffb0.js';

function Divider({
  componentEl: Component,
  margin,
  orientation,
  fullWidth,
  flexItem,
  ...otherProps
}) {
  let cssClasses = ['st_divider'];
  if (fullWidth) cssClasses.push('st_width--full');
  cssClasses.push(`st_divider--${orientation}`);
  if (flexItem) cssClasses.push('st_divider--flex');
  cssClasses = addSpacingClasses({
    margin,
    cssClasses
  });
  return /*#__PURE__*/React.createElement(Component, _extends({
    role: "separator",
    className: cssClasses.join(' ')
  }, otherProps));
}
Divider.propTypes = {
  /** dom element or component to use for outermost wrapper */
  componentEl: props,
  /** margin for component, if any */
  margin: marginPropTypes,
  /** whether to explicitly take up 100% width */
  fullWidth: PropTypes.bool,
  /** whether divider or horizontal or vertical */
  orientation: PropTypes.oneOf(['vertical', 'horizontal']),
  /** whether divider appears inside a flexbox, e.g. Group or Grid components */
  flexItem: PropTypes.bool
};
Divider.defaultProps = {
  componentEl: 'hr',
  margin: {
    all: 'none'
  },
  fullWidth: false,
  orientation: 'horizontal',
  flexItem: false
};

export { Divider as D };
